export function buildMetaTitle(pageTitle: string) {
	return `MeinTraktor HändlerLogin » ${pageTitle}`;
}
